// extracted by mini-css-extract-plugin
export var lbContainerOuter = "x_tR";
export var lbContainerInner = "x_tS";
export var movingForwards = "x_tT";
export var movingForwardsOther = "x_tV";
export var movingBackwards = "x_tW";
export var movingBackwardsOther = "x_tX";
export var lbImage = "x_tY";
export var lbOtherImage = "x_tZ";
export var prevButton = "x_t0";
export var nextButton = "x_t1";
export var closing = "x_t2";
export var appear = "x_t3";